import type { FC } from 'react';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components/macro';

const TicketsListViewLoader: FC = () => {
  const theme = useTheme();

  return (
    <ContentLoader
      data-testid="tickets-list-loading"
      speed={2}
      width="100%"
      height="100vh"
      backgroundColor={theme.colors.surface}
      foregroundColor={theme.colors.primary.variant6}
    >
      <rect x="0" y="0" width="100%" height="100%" />
    </ContentLoader>
  );
};

export default TicketsListViewLoader;
